import { TransformDate } from '../../../decorators/transform-date.decorator';
import { TransformInt } from '../../../decorators/transform-int.decorator';
import { AppSubjectEnum } from '../../authz/enums/app-subject.enum';
import { StatusTrackingScopeEnum } from '../enums/status-tracking-scope.enum';

/**
 * Create status tracking DTO
 */
export class CreateStatusTrackingDto<T> {
	sourceSubject!: AppSubjectEnum;
	@TransformInt()
	sourceId!: number;
	targetSubject!: AppSubjectEnum;
	@TransformInt()
	targetId!: number;
	status!: T;
	scope!: StatusTrackingScopeEnum;
	@TransformDate()
	effectiveFrom!: Date;
	@TransformDate()
	effectiveTo?: Date;
}
